import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './GenericCard.scss';
import { Card, CardActions, CardContent, CardHeader } from '@material-ui/core';
import { getMergedClassNames } from '../../utils/HTMLUtils';
import RefreshIcon from '../Icons/RefreshIcon';

const rootClassName = styles.rootClassName;

class GenericCard extends Component {
  getSendingIcon() {
    if (!this.props.sending) {
      return '';
    }
    return (
      <RefreshIcon
        className={getMergedClassNames([rootClassName + '-sending-icon'])}
      />
    );
  }

  getCardActionsProps = () => {
    const props = {
      ...(this.props.CardActionsProps || {}),
    };
    return {
      ...props,
      className: getMergedClassNames([
        props.className || '',
        rootClassName + '-card-actions',
      ]),
    };
  };

  getCardContentProps = () => {
    const props = {
      ...(this.props.CardContentProps || {}),
    };
    return {
      ...props,
      className: getMergedClassNames([
        props.className || '',
        rootClassName + '-card-content',
      ]),
    };
  };

  getCardHeaderProps = () => {
    const props = {
      ...(this.props.CardHeaderProps || {}),
    };
    return {
      ...props,
      className: getMergedClassNames([
        props.className || '',
        rootClassName + '-card-header',
      ]),
      title: this.props.title,
    };
  };

  getCardProps = () => {
    return {
      className: getMergedClassNames([
        rootClassName + '-card',
        this.props.className || '',
      ]),
    };
  };

  getTopContent = () => {
    return (
      <div className={rootClassName + '-top-content'}>
        {this.props.topContent}
      </div>
    );
  };

  getBottomContent = () => {
    return (
      <div className={rootClassName + '-bottom-content'}>
        {this.props.bottomContent}
      </div>
    );
  };

  render() {
    return (
      <Card {...this.getCardProps()}>
        {this.getSendingIcon()}
        {typeof this.props.topContent === 'object'
          ? this.getTopContent()
          : null}
        <CardHeader {...this.getCardHeaderProps()} />
        <CardContent {...this.getCardContentProps()}>
          {this.props.children}
        </CardContent>
        {this.props.actions ? (
          <CardActions {...this.getCardActionsProps()}>
            <div className={rootClassName + '-card-actions-container'}>
              {this.props.actions}
            </div>
          </CardActions>
        ) : null}
        {typeof this.props.bottomContent === 'object'
          ? this.getBottomContent()
          : null}
      </Card>
    );
  }
}

GenericCard.propTypes = {
  className: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.element,
  ]).isRequired,
  actions: PropTypes.object,
  totalSteps: PropTypes.number,
  currStepIndex: PropTypes.number,
  sending: PropTypes.bool,
  titleHint: PropTypes.string,
  topContent: PropTypes.object,
  bottomContent: PropTypes.object,
  CardHeaderProps: PropTypes.object,
  CardContentProps: PropTypes.object,
  CardActionsProps: PropTypes.object,
};

export default GenericCard;
